var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',{staticClass:"layout gutter"},[_c('div',{staticClass:"layout-item size-33 small-size-100"},[_c('user-profile-card',{attrs:{"user":_vm.user}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }